export interface AuthenticationResponse {
  token: string;
  orderRef: string;
  autoStartToken: string;
}
export interface QrTokenResponse {
  qrToken: string;
}

export interface CollectStatusResponse extends AuthenticationResponse {
  token: string;
  status: string;
  qrToken: string;
}

export enum Properties {
  FullName = 'fullName',
  PersonalIdentityNumber = 'personalIdentityNumber',

  RequestAuthentication = 'requestAuthentication',
  IsAuthenticated = 'isAuthenticated',
  IsAuthenticationOngoing = 'isAuthenticationOngoing',
  AuthenticationError = 'authenticationError',
  AuthenticationWarning = 'authenticationWarning',
  Authenticate = 'authenticate',
  CancelAuthentication = 'cancelAuthentication',
  IsCancellationOngoing = 'isCancellationOngoing',
  StartTime = 'startTime',

  CollectStatus = 'collectStatus',
  GetQrToken = 'getQrToken',
  EndSession = 'endSession',
  ExpireSession = 'expireSession',
  Init = 'init',
  Token = 'token',
  QrToken = 'qrToken',
  AutoStartToken = 'autoStartToken',
  Jwt = 'jwt'
}
